import Vue from 'vue';
import Vuex from 'vuex';
import eventBus from '@/utils/event-bus'
import patient from './patient'
import AIIdentipy from './AIIdentipy'
import theme from './theme'

import { readPushNotify } from '@/service/task'
Vue.use(Vuex);
const state = {
  isLogin: false,
  conversationList: [], //会话列表
  messageList: [],
  conversation: {},
  conversationID: '',
  scrollTop: 0,
  isImSign: false,//im是否登录成功
  unreadCount: false,//会话未读总数更新(TOTAL_UNREAD_MESSAGE_COUNT_UPDATED)这个api是否监听到
  isRoll: true, //是否需要页面滚动
  isPatient: false, //今天，近一周数据是否存在
  institution: {}, //选择机构
  showGroupNike: true, //聊天页面，是否展示群昵称
  chatGroupList: [], //聊天列表--页面展示
  nativeInfo: {
    token: null,
    userId: null
  }, // 设备信息
  wxChatExtList:[],//自定义消息type201的数据
  msgDialogShow: false, //消息提示框是否显示
  renList:[
      {
          name:"张女士",
          headUrl:"https://lk-shuzhizhongtai-common.oss-cn-beijing.aliyuncs.com/ai-laikang-com/IntelligentFiveTeachersWx/pagesH5/demo/kouQiang/new/zhang-nv-shi.png",
          desc:"",
          userId:1000,
          type:1,
          class:"",
          gender: 2,
          mobile: 15827377747,
          age: 41,
          sculptureIcon:"https://lk-shuzhizhongtai-common.oss-cn-beijing.aliyuncs.com/ai-laikang-com/IntelligentFiveTeachersWx/pagesH5/demo/alert%402x.png",
          
      },
      {
          name:"张叔叔",
          headUrl:"https://lk-shuzhizhongtai-common.oss-cn-beijing.aliyuncs.com/ai-laikang-com/IntelligentFiveTeachersWx/pagesH5/demo/zhangshushu.png",
          desc:"近七日血压波动，无规律服药",
          userId:1001,
          type:1,
          class:"zc",
          gender: 1,
          mobile: 135999838828,
          age: 68,
          sculptureIcon:"https://lk-shuzhizhongtai-common.oss-cn-beijing.aliyuncs.com/ai-laikang-com/IntelligentFiveTeachersWx/pagesH5/demo/alert%402x.png",
          
      },
      {
          name:"李先生",
          headUrl:"https://lk-shuzhizhongtai-common.oss-cn-beijing.aliyuncs.com/ai-laikang-com/IntelligentFiveTeachersWx/pagesH5/demo/lixiansheng.png",
          desc:"体重连续上升，低脂饮食",
          userId:1002,
          type:1,
          class:"",
          gender: 1,
          mobile: 189447277748,
          age: 41,
          sculptureIcon:"https://lk-shuzhizhongtai-common.oss-cn-beijing.aliyuncs.com/ai-laikang-com/IntelligentFiveTeachersWx/pagesH5/demo/alert%402x.png",
          
      },
      {
          name:"李明",
          headUrl:"https://lk-shuzhizhongtai-common.oss-cn-beijing.aliyuncs.com/ai-laikang-com/IntelligentFiveTeachersWx/pagesH5/demo/kouQiang/new/li-ming.png",
          desc:"",
          userId:1003,
          type:1,
          class:"",
          gender: 1,
          mobile: 13388473382,
          age: 12,
          sculptureIcon:"https://lk-shuzhizhongtai-common.oss-cn-beijing.aliyuncs.com/ai-laikang-com/IntelligentFiveTeachersWx/pagesH5/demo/%20yueyu5%402x.png",
          
      },
  ],
  signedDoctor:{
    // uni.getStorageSync("TIMGroupInfo")
    //"signId":"签约id",
    //"doctorId":"医生id"
		//签约状态：sign_fail 失败 sign_ing 签约中 sign_success 已成功 sign_rejected 已拒绝 sign_out_apply申请解约 sign_ter 已解约 sign_expired 到期
  },//签约医生
  groupLeaderInfo:{},//群主信息
};

const store = new Vuex.Store({
  namespaced: true,
  modules: {
    patient,
    AIIdentipy,
    theme
  },
  state,
  getters: {
    userInfo: (state) => {
      return state.userInfo;
    },
  },
  mutations: {
    setscrollTop(state, payload) {
      state.scrollTop = payload;
    },
    setConversationList(state, payload) {
      state.conversationList = payload;
    },
    setConversation(state, payload) {
      state.conversation = payload;
    },
    setConversationID(state, payload) {
      state.conversationID = payload;
    },
    resetConversationID(state) {
      state.conversationID = '';
    },
    setMessageList(state, payload) {
      state.messageList = payload;
    },
    setMessageIndex(state, payload) {
      console.log('setMessageIndex更新===', payload);
      Vue.set(state.messageList, payload.index,payload.data);
    },
    resetChat(state) {
      state.messageList = [];
    },
    SET_IS_SIGN(state, payload) {
      state.isImSign = payload;
    },
    SET_UNREAD_COUNT(state, payload) {
      state.unreadCount = payload;
    },
    SET_IS_ROLL(state, payload) {
      state.isRoll = payload;
    },
    SET_IS_PATIENT(state, payload) {
      state.isPatient = payload;
    },
    SET_INSTITUTION(state, payload) {
      state.institution = payload;
    },
    SET_SHOW_GROUP_NIKE(state, payload) {
      state.showGroupNike = payload;
    },
    SET_CHAT_GROUP_LIST(state, payload) {
      state.chatGroupList = payload;
    },
    SET_NATIVE_INFO(state, data) {
      state.nativeInfo = data
    },
    SET_GROUP_LEADER_INFO(state, data) {
      state.groupLeaderInfo = data
    },
    SET_WX_CHAT_EXT_DATA(state, data) {
      state.wxChatExtList = data
    },
    SET_SIGNED_DOCTOR(state, data) {
      state.signedDoctor = data
    },
    SET_MSG_DIALOG_SHOW(state, data) {
      state.msgDialogShow = data
    },
    SET_IMAGE_RECOGNITION_RESULT(state, data) {
      const index = state.messageList.findIndex(item => item.random === data.random)
      if (index !== -1) {
        state.messageList[index].srcData = state.messageList[index].srcData || {}
        state.messageList[index].srcData.ext = state.messageList[index].srcData.ext || {}
        state.messageList[index].srcData.ext.imageRecognition = JSON.parse(data.extend)
      }
    }
  },
  actions: {
    setNativeInfo(state, data) {
      state.commit('SET_NATIVE_INFO', data)
    },
    setGroupLeaderInfo(state, data) {
      state.commit('SET_GROUP_LEADER_INFO', data)
    },
    setMsgDialogShow(state, data) {
      state.commit('SET_MSG_DIALOG_SHOW', data)
    },
    // 收到ai图片识别结果，更新消息数据
    setImageRecognitionResult(state, data) {
      if (data.extend) state.commit('SET_IMAGE_RECOGNITION_RESULT', data)
    },
    // 大屏消息处理逻辑
    LSMessageProcessing(state, data) {
      try {
        const result = JSON.parse(data.result)
        const remark = result.showroomEvent.remark && JSON.parse(result.showroomEvent.remark) || ''
        const offeredCode = result.showroomEvent.offeredCode
        if (offeredCode) eventBus.$emit(offeredCode, {...remark,showText:result.showroomEvent.showText})
        data.pushId && readPushNotify({id: data.pushId})
      } catch (error) {
      }
    },
    setSignedDoctor(context, data){
      context.commit("SET_SIGNED_DOCTOR", data)
    }
  },
});
export default store;